import { render, staticRenderFns } from "./MessagesProject.vue?vue&type=template&id=093c7ff2&scoped=true&"
import script from "./MessagesProject.vue?vue&type=script&lang=js&"
export * from "./MessagesProject.vue?vue&type=script&lang=js&"
import style0 from "./MessagesProject.vue?vue&type=style&index=0&id=093c7ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093c7ff2",
  null
  
)

export default component.exports